import { render } from "./App.vue?vue&type=template&id=035ba578&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/main.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=035ba578&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035ba578"]])

export default __exports__